import { render, staticRenderFns } from "./OrderComponentJosipovDom.vue?vue&type=template&id=8012f73a&"
import script from "./OrderComponentJosipovDom.vue?vue&type=script&lang=js&"
export * from "./OrderComponentJosipovDom.vue?vue&type=script&lang=js&"
import style0 from "./OrderComponentJosipovDom.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports